export const paymentTypes = [
    {
      id: 'uuid-1',
      name: 'cash',
      display_name: 'نقداً',
      type: 'cash',
    },
    {
      id: 'uuid-2',
      name: 'bank_transfer',
      display_name: 'تحويل بنكي',
      type: 'bank_transfer',
    },
    {
      id: 'uuid-3',
      name: 'cheque',
      display_name: 'شيك',
      type: 'cheque',
    },
    {
      id: 'uuid-4',
      name: 'visa',
      display_name: 'فيزا',
      type: 'visa',
    },
  ];
  